import { emptyGridImg } from 'utils/helpers';
import { getDomainValue } from 'utils/domain';

import styles from './style.module.css';

export default function ProductPlaceholder({ square = false }: { square?: boolean }) {
  const camperImage = square ? '/assets-new/loading-square.png' : '/assets-new/loading-new.png';
  return (
    <div className={styles.gridItem}>
      <div className={styles.gridPhoto}>
        <img
          src={getDomainValue({
            camper: camperImage,
            nnormal: emptyGridImg,
            camperlab: '/assets-new/camperlab/camperlab-loading-image-card.webp',
          })}
          className={styles.image}
          alt=""
        />
      </div>
      {getDomainValue({
        camper: null,
        nnormal: <div className={styles.gridContent} />,
        camperlab: null,
      })}
    </div>
  );
}
